import {
  ResourceStore,
  User as Model,
} from '@/internal';

const store = new ResourceStore({
  model: Model,
});

export default store.toObject();
